import { $, $$ } from '@3pc/dom';
import { Accordion } from '@3pc/accordion';

// accordion selector (secect the elemet that contains the handler and target for each accordion)
const accordionItems = $$('.accordion__item');

const initAccordion = container => {
  // handler is the button (burger, close, menu etc.)
  const handler = $('.accordion__trigger', container);
  // target is the element that should be opened/closed
  const target = $('.accordion__panel', container);
  // target is the element that should be opened/closed
  const targetInner = $('.accordion__panel-inner', target);

  // if no handler, target or targetInner is found, return
  if (!handler || !target || !targetInner) return;

  // initialize accordion with options
  const accordion = new Accordion({
    target,
    targetInner,
    handler,
    easing: 'easeInOutQuart',
    duration: 400,
    initOpened: false,
    openClassName: 'is-open',
    closeInstances: [
      /* array of other accordion instances */
    ],
    toggleStart: (element, state, isOpen) => {
      // do something after animation started
    },
    toggleEnd: (element, state, isOpen) => {
      // do something after animation completes
    },
  });
  accordion.init();
};

// loop over each accordion item and initialize it
accordionItems.forEach(accordionItem => {
  return initAccordion(accordionItem);
});
